import React from 'react';
import PropTypes from 'prop-types';

import { StyledButtonControlled } from './Styles';

const propTypes = {
  testId: PropTypes.string,
  children: PropTypes.node,
  variant: PropTypes.bool.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func
};

const defaultProps = {
  testId: undefined,
  children: undefined,
  className: undefined,
  onClick: undefined
};

const ControlledButton = ({
  testId,
  variant,
  children,
  className,
  onClick
}) => {
  return (
    <StyledButtonControlled
      data-testid={testId}
      variant={variant ? 'selected' : 'unselected'}
      className={className}
      onClick={onClick}
    >
      {children}
    </StyledButtonControlled>
  );
};

ControlledButton.propTypes = propTypes;
ControlledButton.defaultProps = defaultProps;

export default ControlledButton;
